import { useSuspenseInfiniteQuery } from '@tanstack/react-query'
import { useMedplum } from '@medplum/react'
import { config } from '@/config'

export type FaxSentItem = {
  messageId: string
  recipient: {
    phoneNumber: string
    extensionNumber: string
    name: string
  }
  messageStatus: string
  sentAt: string
  pageCount: number
  attachment?: {
    id: string
    contentType: string
    uri: string
  }
}

type SentFaxListResponse = {
  items: FaxSentItem[]
  page: number
  perPage: number
  totalPages: number
  totalElements: number
}

export const faxSentQueryKey = () => ['fax-sent'] as const

export function useFaxSent() {
  const medplum = useMedplum()

  return useSuspenseInfiniteQuery({
    initialPageParam: 1,
    queryKey: faxSentQueryKey(),
    queryFn: async ({ pageParam }) => {
      const baseUrl = config.middlewareUrl || ''
      const params = new URLSearchParams({
        page: String(pageParam),
        perPage: '50',
      })

      const response = await fetch(`${baseUrl}/order/sent-faxes?${params}`, {
        headers: {
          Authorization: `Bearer ${medplum.getAccessToken()}`,
        },
      })

      if (!response.ok) {
        throw new Error(`Failed to fetch sent faxes: ${response.status}`)
      }

      const data: SentFaxListResponse = await response.json()

      return {
        items: data.items,
        hasNextPage: data.page < data.totalPages,
      }
    },
    getNextPageParam: (lastPage, _allPages, lastPageParam) => {
      if (!lastPage.hasNextPage) return undefined
      return lastPageParam + 1
    },
  })
}
